module.exports = __webpack_public_path__ + "img/survey-dog.92a9bc9b.png";